/**
 * Contract Notices Service
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.6.13
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

export interface BusinessEntityDetailsResponse { 
    id: string;
    name?: string;
    lang?: BusinessEntityDetailsResponse.LangEnum;
    translated?: boolean;
    businessEntityId?: string;
}
export namespace BusinessEntityDetailsResponse {
    export type LangEnum = 'MK' | 'EN' | 'AL';
    export const LangEnum = {
        MK: 'MK' as LangEnum,
        EN: 'EN' as LangEnum,
        AL: 'AL' as LangEnum
    };
}